import { useEffectiveAccess } from '@/lib/effectiveAccess';

/**
 * spec-klantsimulatie-aanmeldingen: een interne rol die géén klant kiest, ziet geen aanmeldingen.
 * "Géén klant" is: niet simulerend, of simulerend zonder klantnummer.
 */
export function useZonderGekozenKlant(): boolean {
  const { user, isSimulating, simulatedGln } = useEffectiveAccess();
  return !!user && user.role !== 'customer' && !(isSimulating && simulatedGln);
}
